import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { useHeadingLevel } from '../../../utils/heading-level-context/HeadingLevelContext.es.js';
import { clamp } from '../../../utils/clamp.es.js';
import { baseReset } from '../../../style-mixins/reset.es.js';

const Styles = labelStyles("Heading", {
  root: css`
    ${baseReset};
    display: block;
  `
});
const Heading = ({ children, className, style }) => {
  const { level } = useHeadingLevel();
  const headingLevel = clamp(level, 1, 6);
  const Tag = `h${headingLevel}`;
  return jsx(Tag, { css: Styles.root, className, "data-zds": true, style }, children);
};

export { Heading };
//# sourceMappingURL=Heading.es.js.map
